import api from "../lib/axios";

/**
 * Fetch all availability slots for an exhibitor booth (via members)
 */
export const getExhibitorAvailability = async (exhibitorId) => {
  return api.get(`/exhibitor/meetings/availability/exhibitor/${exhibitorId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch availability for a specific booth member
 */
export const getMemberAvailability = async (boothMemberId) => {
  return api.get(`/exhibitor/meetings/availability/member/${boothMemberId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Bulk save availability slots (Transactional)
 */
export const bulkSaveAvailability = async (data) => {
  return api.post(`/exhibitor/meetings/availability/bulk`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch all bookings for an exhibitor
 */
export const getExhibitorBookings = async (exhibitorId) => {
  return api.get(`/exhibitor/meetings/bookings/exhibitor/${exhibitorId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch all bookings for an attendee user
 */
export const getAttendeeBookings = async (attendeeUserId) => {
  return api.get(`/exhibitor/meetings/bookings/attendee/${attendeeUserId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch all bookings for a specific booth member
 */
export const getMemberBookings = async (boothMemberId) => {
  return api.get(`/exhibitor/meetings/bookings/member/${boothMemberId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Update a meeting booking (status/notes)
 */
export const updateBooking = async (id, data) => {
  return api.put(`/exhibitor/meetings/bookings/${id}`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Delete/Cancel a booking
 */
export const deleteBooking = async (id) => {
  return api.delete(`/exhibitor/meetings/bookings/${id}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Create a new booking
 */
export const addBooking = async (data) => {
  return api.post(`/exhibitor/meetings/bookings`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Fetch meeting settings for a booth member
 */
export const getMeetingSettings = async (boothMemberId) => {
  return api.get(`/exhibitor/meetings/settings/${boothMemberId}`, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Update/Create meeting settings for a booth member
 */
export const updateMeetingSettings = async (data) => {
  return api.post(`/exhibitor/meetings/settings`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Download .ics calendar file for a meeting
 */
export const downloadMeetingCalendar = async (bookingId) => {
  return api.get(`/exhibitor/meetings/bookings/${bookingId}/calendar`, {
    responseType: 'blob',
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};
